import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import stylesCourse from 'styles/Course.module.scss';
import { FaArrowsAltH } from 'react-icons/fa';
const FormatContentArrow = ({ index, list, commonHeight }) => {
  if (list?.length > 0) {
    return (
      <>
        {list.map((item, index) => (
          <div key={index}>
            <div
              className={
                `flexRow px-md-2 px-05  ${stylesCourse['item-section-normal']}` +
                ` ${stylesCourse['item-section-enabled']}`
              }
              style={{
                maxWidth: '40rem',
                border: 'none',
                height:
                  !commonHeight || !commonHeight?.length === 0
                    ? 'auto'
                    : commonHeight[index],
              }}
            >
              <span className={stylesCourse['item-unit-label']}>
                <span className={stylesCourse['item-unit-title']}>{item}</span>
              </span>
            </div>
          </div>
        ))}
      </>
    );
  }

  return (
    <>
      {[...Array(index)].map((item, index) => (
        <div key={index}>
          <div
            className={
              `flexRow px-md-2 px-05 py-05 justify-content-center ${stylesCourse['item-section-normal']}` +
              ` ${stylesCourse['item-section-enabled']}`
            }
            style={{
              maxWidth: '40rem',
              border: 'none',
              height:
                !commonHeight || !commonHeight?.length === 0
                  ? 'auto'
                  : commonHeight[index],
            }}
          >
            <span className={stylesCourse['item-unit-label']}>
              <span className={stylesCourse['item-unit-title']}>
                <div className="customatch_icons_dnd">
                  <FaArrowsAltH color="#c1c9d4" />
                </div>
                <div className="custom_match_icons_dnd">
                  <img
                    src="/images/course/matchIcon.png"
                    alt="dragAndDrop"
                    width={83}
                    height={35}
                  />
                </div>
              </span>
            </span>
          </div>
        </div>
      ))}
    </>
  );
};

FormatContentArrow.propTypes = {
  index: PropTypes.number,
  list: PropTypes.array,
};

export default FormatContentArrow;
